// extracted by mini-css-extract-plugin
export default {"root":"option_root__kFXrR","input":"option_input__hADUG","label":"option_label__pxjlG","action":"option_action__0+Es7"};